import Label from "./Label";

export default class {
  constructor (labels) {

    this.instances = labels;

    for (const label of labels) {
      new Label(label);
    }
  }
}